import styled from 'styled-components';
import { InfoHistoryList } from '../../assets/datas/ConstantLists';
import Year from './Year';
import Data from './Data';

const MainDiv = styled.div`
  margin: 3rem 5rem;
`

const ContentDiv = styled.div`
  width: 100%;
  display: flex;
`

const Test = () => {
  const historyList = InfoHistoryList;

  return (
    <MainDiv>
      <ContentDiv>        
        <Year />
        <Data />
      </ContentDiv>
    </MainDiv>
  );
};

export default Test;